import axios, { AxiosRequestConfig } from 'axios'
import { store } from '../store';
import { logout, setAuth } from '../store/reducers/user.reducer';
import EquimetreRequestConfig from './equimetreRequestConfig';
import { User } from './user';

var retry = false

const axiosInstanceHubstripe = axios.create({
    baseURL: process.env.REACT_APP_API_HUBSTRIPE_URI, // Replace with your API base URL
    headers: {
        // Accept: 'application/json'
    }
});

// // Request interceptor
// axiosInstance.interceptors.request.use(
//     (config) => {
//         // Modify the request config here (e.g., add headers, authentication tokens)
//         const accessToken = localStorage.getItem("token");
//         // ** If token is present add it to request's Authorization Header
//         if (accessToken) {
//             if (config.headers) config.headers.Authorization = `Bearer ${accessToken}`;
//         }
//         return config;
//     },
//     (error) => {

//         return Promise.reject(error);
//     }
// );

// Response interceptor
// axiosInstance.interceptors.response.use(
//     (response) => {
//         // Modify the response data here (e.g., parse, transform)
//         const config = response.config as EquimetreRequestConfig;

//         if (config.useHydraArrayTransform && response.data && response.data['hydra:member']) {
//             // Transform the data to extract `hydra:member` if `useHydraTransform` is true
//             response.data = response.data['hydra:member'];
//         }

//         return response;
//     },
//     async (error) => {
//         // Handle response errors here

//         if (error?.response?.status === 401 && !retry) {
//             retry = true; // Mark the request as retried to avoid infinite loops.

//             try {
//                 let refresh_token = localStorage.getItem('refresh_token')

//                 if (!refresh_token) throw Error('No refresh token found')

//                 let response = await User.refreshUserToken(refresh_token)

//                 let accessToken = response.data.token

//                 localStorage.setItem('token', response.data.token)
//                 store.dispatch(setAuth(true))

//                 axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;



//             } catch (error) {
//                 store.dispatch(logout())
//             } finally {
//                 retry = false
//             }
//         }
//         return Promise.reject(error);
//     }
// );

export default axiosInstanceHubstripe;